import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UtilityService {

    base64Chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-.';

    /**
     * adapted from String.hashCode()
     * 64 bit hash function
     *
     * @param {string} str
     * @return {number}
     */
    hash(str: string): number {
        let h = 1275801696342597; // prime
        if (!str) {
            str = '';
        } else {
            str = String(str);
        }

        const len = str.length;
        if (len < 1) {
            return h;
        }

        for (let i = 0; i < len; i++) {
            const c = str.charCodeAt(i);
            // eslint-disable-next-line no-bitwise
            h = ((h << 5) - h) + c;

            // Convert to 32bit integer
            // eslint-disable-next-line no-bitwise
            h = h & h;
        }

        return h;
    }

    /**
     * generate random string
     *
     * @param {number} len
     * @return {string}
     */
    generateRandomString(len: number): string {
        let randomString = '';

        for (let i = 0; i < len; i++) {
            randomString = randomString + this.base64Chars.substr(Math.floor((Math.random() * this.base64Chars.length - 1)), 1);
        }

        return randomString;
    }
}
